import type { FC } from "react";

import style from "./styles/FormWidget.module.scss";

export interface AddonProps {
  label: string;
}

const Addon: FC<AddonProps> = (props) => {
  return <div className={style.addon}>{props.label}</div>;
};

export { Addon };
